import { render, staticRenderFns } from "./ContingentTable.vue?vue&type=template&id=11af930f&scoped=true&"
import script from "./ContingentTable.vue?vue&type=script&lang=ts&"
export * from "./ContingentTable.vue?vue&type=script&lang=ts&"
import style0 from "./ContingentTable.vue?vue&type=style&index=0&id=11af930f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11af930f",
  null
  
)

export default component.exports